import _classCallCheck from "/vercel/path2/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path2/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path2/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path2/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BufferGeometry } from '../core/BufferGeometry.js';
import { Float32BufferAttribute } from '../core/BufferAttribute.js';

var PlaneGeometry = /*#__PURE__*/function (_BufferGeometry) {
  _inherits(PlaneGeometry, _BufferGeometry);

  var _super = _createSuper(PlaneGeometry);

  function PlaneGeometry() {
    var _this;

    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var widthSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var heightSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, PlaneGeometry);

    _this = _super.call(this);
    _this.type = 'PlaneGeometry';
    _this.parameters = {
      width: width,
      height: height,
      widthSegments: widthSegments,
      heightSegments: heightSegments
    };
    var width_half = width / 2;
    var height_half = height / 2;
    var gridX = Math.floor(widthSegments);
    var gridY = Math.floor(heightSegments);
    var gridX1 = gridX + 1;
    var gridY1 = gridY + 1;
    var segment_width = width / gridX;
    var segment_height = height / gridY; //

    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = [];

    for (var iy = 0; iy < gridY1; iy++) {
      var y = iy * segment_height - height_half;

      for (var ix = 0; ix < gridX1; ix++) {
        var x = ix * segment_width - width_half;
        vertices.push(x, -y, 0);
        normals.push(0, 0, 1);
        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);
      }
    }

    for (var _iy = 0; _iy < gridY; _iy++) {
      for (var _ix = 0; _ix < gridX; _ix++) {
        var a = _ix + gridX1 * _iy;
        var b = _ix + gridX1 * (_iy + 1);
        var c = _ix + 1 + gridX1 * (_iy + 1);
        var d = _ix + 1 + gridX1 * _iy;
        indices.push(a, b, d);
        indices.push(b, c, d);
      }
    }

    _this.setIndex(indices);

    _this.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    _this.setAttribute('normal', new Float32BufferAttribute(normals, 3));

    _this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    return _this;
  }

  return PlaneGeometry;
}(BufferGeometry);

export { PlaneGeometry, PlaneGeometry as PlaneBufferGeometry };